import request from '@/utils/request'


// 查询动态话题列表
export function listTalk(query) {
  return request({
    url: '/dynamics/talk/list',
    method: 'get',
    params: query
  })
}

// 查询动态话题分页
export function pageTalk(query) {
  return request({
    url: '/dynamics/talk/page',
    method: 'get',
    params: query
  })
}

// 查询动态话题详细
export function getTalk(data) {
  return request({
    url: '/dynamics/talk/detail',
    method: 'get',
    params: data
  })
}

// 新增动态话题
export function addTalk(data) {
  return request({
    url: '/dynamics/talk/add',
    method: 'post',
    data: data
  })
}

// 修改动态话题
export function updateTalk(data) {
  return request({
    url: '/dynamics/talk/edit',
    method: 'post',
    data: data
  })
}

// 删除动态话题
export function delTalk(data) {
  return request({
    url: '/dynamics/talk/delete',
    method: 'post',
    data: data
  })
}
